import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ViewApI } from 'api/views';
import { ViewType } from 'api/views/types';
import { Views, ViewTransformer } from 'components/molecules/views';
import { load } from 'components/molecules/views/core';
import {
  ApiTimesheetReportViewDefinition,
  TimesheetReportViewDefinition,
} from 'components/organisms/timesheets/reports/views/types';
import { GENERAL_API_STALE } from 'config/query-config';

type TimesheetReportsViews = [string, string];
export const getTimesheetReportsViewsQuery = (): TimesheetReportsViews => [
  'views',
  'timesheet-reports',
];
export const useTimesheetReportViewsQuery = (
  viewTransformer: ViewTransformer<
    ApiTimesheetReportViewDefinition,
    TimesheetReportViewDefinition
  >,
  queryOptions: UseQueryOptions<
    Views<TimesheetReportViewDefinition>,
    unknown,
    Views<TimesheetReportViewDefinition>,
    TimesheetReportsViews
  > = {},
): UseQueryResult<Views<TimesheetReportViewDefinition>> =>
  useQuery(
    getTimesheetReportsViewsQuery(),
    () =>
      ViewApI.getAllViews<ApiTimesheetReportViewDefinition>(
        ViewType.TimesheetReports,
      ).then((data) => load(data.map(viewTransformer.from))),
    {
      staleTime: GENERAL_API_STALE,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      ...queryOptions,
    },
  );
